import { render, staticRenderFns } from "./platformCouponsRecord.vue?vue&type=template&id=45b13306&scoped=true"
import script from "./platformCouponsRecord.vue?vue&type=script&lang=ts"
export * from "./platformCouponsRecord.vue?vue&type=script&lang=ts"
import style0 from "./platformCouponsRecord.vue?vue&type=style&index=0&id=45b13306&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b13306",
  null
  
)

export default component.exports